<template>
	<div class="radio-pill">
		<input
			type="radio"
			:id="id"
			:checked="modelValue === value"
			:value="value"
			@change="$emit('change', value)"
		/>
		<label class="radio-pill__label" :for="id">
			<slot>Label</slot>
		</label>
	</div>
</template>

<script>
export default {
	name: 'FlytRadioPill',

	props: {
		value: [Boolean, String],
		id: String,
		modelValue: {
			type: [Boolean, String],
			default: ''
		}
	},

	computed: {
		isChecked() {
			return this.modelValue === this.value
		}
	}
}
</script>
